import React from 'react'
import StarIcon from '../../ui/icons/star'
import StarEmptyIcon from '../../ui/icons/star-empty'
import StarHalfIcon from '../../ui/icons/star-half'

interface Props {
  score: number
  count?: number
  fill?: string
  stroke?: boolean
  children?: React.ReactNode
}

const renderAppStoreReviewCount = count => {
  function kFormatter(num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1) as any) + 'k'
      : Math.sign(num) * Math.abs(num)
  }

  return `(${kFormatter(count)})`
}

const Rating: React.FC<Props> = ({
  score,
  count,
  fill = 'white',
  children,
  stroke = false,
}) => {
  const numArray = score.toString().split('.')
  const wholeNum = parseInt(numArray[0])
  const decimalNum = parseFloat(`0.${numArray[1]}`)

  let fullStarCount = wholeNum

  const lastStarIsFull = decimalNum > 0.5
  fullStarCount += lastStarIsFull ? 1 : 0
  const hasHalfStar = decimalNum >= 0.25 && decimalNum <= 0.5
  const emptyStarCount = 5 - fullStarCount - (hasHalfStar ? 1 : 0)

  const STAR_ICON_WIDTH = 16

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {/* Full stars */}
      {Array.from({ length: fullStarCount }).map((_, ix) => (
        <StarIcon
          key={ix}
          width={STAR_ICON_WIDTH}
          fill={fill}
          stroke={stroke}
        />
      ))}
      {/* Half stars */}
      {hasHalfStar ? (
        <StarHalfIcon width={STAR_ICON_WIDTH} fill={fill} stroke={stroke} />
      ) : null}
      {/* Empty stars */}
      {Array.from({ length: emptyStarCount }).map((_, ix) => (
        <StarEmptyIcon
          key={ix}
          width={STAR_ICON_WIDTH}
          fill={fill}
          stroke={stroke}
        />
      ))}
      <div style={{ marginLeft: 8, fontSize: 12 }}>{children}</div>
    </div>
  )
}

export const InterstitialRating = ({ score, count }: Props) => {
  return (
    <Rating score={score} count={count} fill="white">
      {renderAppStoreReviewCount(count)}
    </Rating>
  )
}

export const LearningCardRating = ({ score, count, stroke = false }: Props) => {
  // this rounds to the nearest 0.5
  score = Math.round(score * 2) / 2

  return (
    <Rating score={score} count={count} fill="gold" stroke={stroke}>
      {/* {score} / 5 */}
    </Rating>
  )
}
export default Rating
